export class DashboardConfig {
   public pK_TranID: number
   public sequence: number
   public fK_RegID: number
   public firstName: number
   public ageDesc: number
   public categoryName: number
   public party: number
   public userhe: number
   public userar: number
   public useropt: number
   public userdct: number
   public userphy: number
   public userproc: number
   public usercons: number
   public doctor: number
   public optName: number
   public proN: number
   public oldmrdno: number
   public contactNo: number
   public waitingReason: number
   public companyName: number
   public sap: number
   public remarks: number
   public adharCard: number
   public ispd: number
   public totalTime: number
   public pHy: number
   public fK_BranchId: number
   public isActive: boolean
   public returnWidth: number
   public branchName: string
}

export class TimeConfig {
   public pK_TranId: number
   public timeIntervalA: number
   public timeIntervalAColor: string
   public timeIntervalB: number
   public timeIntervalBColor: string
   public timeIntervalC: number
   public timeIntervalCColor: string
   public isActive: boolean
}

export class BranchMaster {
   public pkBranchId: number
   public branchName: string
   public branchCode: string
   public address: string
   public contactPerson: string
   public contactNo: string
   public emailAddress: string
   public faxNo: string
   public line1: string
   public line2: string
   public line3: string
   public line4: string
   public dlno: string
   public tinno: string
   public imageLogo: string
   public isNabhLogo:boolean
   public isHeaderImage: boolean
   public headerImageHeight: string
   public headerImageWidth: string
   public gstNo: string
   public panNo: string
   public fkstateId: number
   public isCentralOpticStore: string
   public isActive: boolean
   public pK_SynchId: string
   public stateName: string
}

export class EmailTypeConfig {
   public attachments: string
   public emailBCC: string
   public emailCC: string
   public emailType: string
   public fileName: string
   public fromMailName: string
   public frommailid: string
   public isActive: boolean
   public messageTemplate: string
   public otp: string
   public pK_TranId: number
   public password: string
   public port: string
   public reqssl: number
   public sendingType: string
   public smtpid: string
   public subject: string
   public templateType: string
   public toEmail: string
   public username: string
}
export class EmailType {
   public id: number
   public type: string
}
export class SendType {
   public id: number
   public type: string
}
export class TemplateType {
   public id: number
   public type: string
}
export class smsconfig{
public pK_TranId: number
public fK_BranchId: number
public initialURL:any
public userNameField :any
public userNameValue:any
public passwordField:any
public passwordValue :any
public senderField :any
public senderValue :any
public numberField :any
public numberValue :any
public messageField:any 
public routeField:any
public route :any  
public authenticationKeyField:any
public authenticationKeyValue:any 
public isActive:boolean
public pK_SynchId:number
public name:any
}


export class PatientConfigurationSetup {
   PK_PatientConfiguratinId: number;
   FK_BranchId: number;
   FK_CityId: number;
   FK_LCityId: number;
   FK_AreaId: number ;
   FK_LAreaId: number ;
   FK_CountryId: number;
   FK_DistrictId:number;
   FK_StateId: number;
   FK_LCountryId: number
   FK_LanguageId: number;
   FK_LDistrictId:number
   FK_GroupNameId: number;
   FK_OccupationId: number;
   FK_ReligionId: number;
   FL_SourceId: number;
   FK_InitialId: number;
   LimitofSkippedAppt: number;
   MandatoryAddress: boolean;
   MandatoryMobile: boolean;
   MandatoryEmergencyMob: boolean;
   MandatoryDOB: boolean;
   MandatoryEmail: boolean;
   MandatoryEMR_OptoName: boolean;
   MandatoryEMR_Finding: boolean;
   MandatoryEMR_Diagnosis: boolean;
   MandatoryEMR_TP: boolean;
   MandatoryEMR_RD: boolean;
   OLDMRNOLABEL: string;
   MandatoryOLDMRNO: boolean;
   MandatoryMaritalStatus: boolean;
   MandatoryEMR_ExamComments: boolean;
   MandatoryEMR_Prognosis: boolean;
   MandatoryEMR_NutritionalAdvice: boolean;
   MandatoryEMR_DocorAdvise: boolean;
   MandatoryReferredby: boolean;
   MandatoryPartyName: boolean;
   MandatoryInitial: boolean;
   MandatoryOcupation: boolean;
   ExaminationTabularFormat: boolean;
   MandatoryLanguage: boolean;
   MandatoryGroupName: boolean;
   MandatoryEMR_OptomRemarks: boolean;
   NotShowPostopinDr: boolean;
   ManatoryNationalID: boolean;
   IsMandatoryNationality: boolean;
   FK_NationalityId: number;
   MandatoryPinCode: boolean;
   MandatoryBPL: boolean;
   MandatoryEMR_Immunization: boolean;
   MandatorySource: boolean;
   MandatoryLastName: boolean;
   IsEdit: boolean;
   branchName:any
   languageName:any
   occupation:any
   initialName:any
   religion:any
   nation:any
   sourceName:any
   FK_LStateId:number
   FK_GroupName:any
}
   

export class ScanDocumentlocationMaster {
   PK_ScanDocLocationId: number;
   FK_BranchId: number;
   ScanDcumentPath1: string;
   ScanDcumentPath2: string;
   IsActive: boolean;
   IsEdit: boolean;
}

export class ArNctPathmaster {
   pK_TranID: number;
   FK_BranchID: number;
   arpath: string;
   nctpath: string;
   lensometer: string;
   companyName: string;
   IsActive: boolean;
   IsEdit: boolean;
}

export class smsMaster{
 public pK_TranId:number
 public fK_BranchId:number
 public smsType:any
 public smsTemplate:any
 public startTime:any
 public endTime:number
 public sendingType:any
 public totalSENTSMS:any
 public isActive:boolean
 public template_Type:any
 public title:any
 public smsRestrictionDateValue:any
 public smsTemplateLocal:any
 public smsExpiryDays:any
 public isEdit:boolean
 public branchName:any
 public fK_CreatedbyId:any
 public createdDateTime:any

}

